import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import React from "react";
import DefaultSettings from './settings';
import Typography from '@material-ui/core/Typography';
import InputLabel from '@material-ui/core/InputLabel';
import { getEnvVariable } from '../../../modules/environmentalList';

export default function DaysTimer(props) {
    const { name, options, value, handleFieldValue, edit, extraProps, required, disabled, helperText, error, contexthelp, ...otherProps } = props
    const { label, xtype, fullWidth, tooltip, FieldProps, ...otherConfigs } = otherProps;
    // let val = ((value === null) || (value === undefined) || (value === '')) ? null : new Date(value);

    let tlabel = <Typography variant={value ? 'h6' : 'caption'} color={error ? 'red' : ''}>{label}{required ? <strong style={{ color: 'red' }}>{' * '}</strong> : ''}
    {tooltip && <Tooltip title={tooltip ? tooltip : null}
        placement="bottom-start" >
        <HelpOutlineIcon color='secondary' fontSize="small" style={{ width: '0.6em', marginBottom: 5, marginLeft: 5 }}
            onClick={(evt) => contexthelp ?
                DefaultSettings.showDrawer(contexthelp) : evt.preventDefault()} />
    </Tooltip>}
</Typography>
    return (
        <FormControl className={name} fullWidth={fullWidth ? fullWidth : true} error={error} disabled={disabled || false}>
            {/* <InputLabel > {tlabel}&nbsp; </InputLabel> */}
            <TextField
               disabled={disabled || false}
               //required={required}
               error={error}
               fullWidth={fullWidth ? fullWidth : true}
               label={tlabel}
                id="time"
                name={name}
                type="time"
                value={value}
                //disabled={disabled || false}
                onChange={(e) => handleFieldValue({ target: { value: e.target.value, name: name, checked: false, }, currentTarget: { dataset: null } })}
                // InputLabelProps={{
                //     shrink: true,
                // }}
                inputProps={{
                    step: 300, // 5 min
                    style: { fontWeight: 500 }
                }}
                {...otherConfigs}
                {...extraProps}
            />
            {helperText && <FormHelperText>{helperText}</FormHelperText>}
        </FormControl>
    );
}
